import { Button } from '@mui/material';
import { ComponentPropsWithoutRef, forwardRef, useImperativeHandle, useRef } from 'react';
import { ExtendButtonBase } from '@mui/material/ButtonBase';
import { ButtonTypeMap } from '@mui/material/Button/Button';

interface ChangeTotalsButtonProps
    extends ComponentPropsWithoutRef<HTMLButtonElement & ExtendButtonBase<ButtonTypeMap>> {
    onChangeTotals: () => void;
}

const ChangeTotalsButton = forwardRef<HTMLButtonElement, ChangeTotalsButtonProps>(
    ({ onChangeTotals, ...props }, forwardedRef) => {
        const ref = useRef<HTMLButtonElement>(null);

        useImperativeHandle(forwardedRef, () => ref.current as HTMLButtonElement);

        return (
            <Button ref={ref} onClick={onChangeTotals} variant="contained" {...props}>
                Änderungen Speichern
            </Button>
        );
    }
);

export default ChangeTotalsButton;
